import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const Niveau = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  let niveau = Math.abs(parseInt(value.value)) + "%";

  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    niveau = Math.abs(parseInt(simValue)) + "%";
  }

  //========================================================================
  // Grafische Darstellung
  return (
    <div
      style={{
        ...props.style,
        backgroundColor: "transparent",
        visibility: props.props.visibility,
      }}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
    >
      <div
        style={{
          position: "absolute",
          bottom: "0px",
          height: niveau,
          width: "100%",
          maxHeight: "100%",
          backgroundColor: props.props.color,
        }}
      ></div>
    </div>
  );
});

export default Niveau;
